const menuButtons = document.querySelectorAll('.mega-menu-button'); // these have dropdowns
const menus = document.querySelectorAll('.mega-menu');

let activeMenu = null;
let activeButton = null;
let closeTimeout = null;

menuButtons.forEach((button, index) => {
  button.addEventListener('mouseenter', () => {
    clearTimeout(closeTimeout);

    // Close any currently open menu first
    if (activeMenu && activeMenu !== menus[index]) {
      closeMenu(activeMenu, activeButton);
    }
    openMenu(menus[index], button);
  });

  button.addEventListener('mouseleave', () => {
    closeTimeout = setTimeout(() => {
      if (activeMenu === menus[index]) {
        closeMenu(menus[index], button);
      }
    }, 150);
  });
});

// Keep menu open while hovering over it
menus.forEach((menu, index) => {
  menu.addEventListener('mouseenter', () => {
    clearTimeout(closeTimeout);
  });

  menu.addEventListener('mouseleave', () => {
    if (menu.classList.contains('show-menu')) {
      closeMenu(menu, menuButtons[index]);
    }
  });
});

// Close on Escape key
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && activeMenu) {
    closeMenu(activeMenu, activeButton);
  }
});


function closeMenu(menu, button) {
  activeMenu = null;
  activeButton = null;
  menu.classList.remove('show-menu');
  document.querySelector('.header').classList.remove('mega-menu-active');
  document.body.classList.remove('primary-nav-open');
  button.classList.remove('active-button');
}


function openMenu(menu, button) {
  if (!button.classList.contains('mega-menu-button')) {
    return;
  }
  activeMenu = menu;
  activeButton = button;
  menu.classList.add('show-menu');
  document.querySelector('.header').classList.add('mega-menu-active');
  document.body.classList.add('primary-nav-open');
  button.classList.add('active-button');
}